import React from 'react';
import cc from 'classcat';
import './criterialist.style.scss';
/**
 * list that shows list of search results (criteria)
 * @param criteria
 * @param onChange
 * @param visible
 * @param listRef
 * @param className
 * @constructor
 */
var CriteriaList = function (_a) {
    var criteria = _a.criteria, onChange = _a.onChange, visible = _a.visible, listRef = _a.listRef, className = _a.className;
    if (!visible)
        return null;
    return (React.createElement("div", { className: cc([className, 'tfm-criteria-list']), ref: listRef },
        React.createElement("ul", null, criteria.map(function (current) { return (React.createElement("li", { key: current.name },
            React.createElement("button", { type: "button", onClick: function () { return onChange(current); } }, current.title))); }))));
};
CriteriaList.defaultProps = {
    visible: false,
};
export default CriteriaList;
